import {getAppState} from "../helpers/tools";

/**
 *
 * @returns {Function}
 */
export const fetchActions = () => {
  return (dispatch, getState) => {
    const state = getAppState( getState() );
    dispatch({
      type: "FETCH_ACTIONS",
      data: {
        history: state.actions.history,
        locations: state.locations.collection,
      }
    });
  }
};
